import React, { useState } from "react";

import { Grid } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { theme } from "../../themes";

import {
  ArrayInput,
  Button,
  CheckboxGroupInput,
  Confirm,
  FormDataConsumer,
  RadioButtonGroupInput,
  SimpleFormIterator,
  TextInput,
} from "react-admin";
import { useForm } from "react-final-form";

import { CustomFieldsDisplayOptions, TrueOrFalse } from "../../utils/constants";
import { AddIcon, RemoveIcon } from "./iconography";
import { getCustomFieldId } from "./CustomFields";

const useStyles = makeStyles((theme) => ({
  checkbox: {
    marginTop: 0,
  },
}));

const validateUnicity = (value, allValues, source) => {
  const allFields = allValues[source];

  if (!value) return { message: "Required" };

  if (allFields) {
    const duplicates = allFields.filter(
      (item) => getCustomFieldId(item?.name) === getCustomFieldId(value)
    ).length;

    if (duplicates > 1) {
      // return an object just like the other validators
      return { message: "Duplicate entry" };
    }

    return undefined;
  }
  return undefined;
};

const DeepRemoveButton = ({ source, refreshFn, ...props }) => {
  const form = useForm();
  var n = props.className.lastIndexOf("-");
  var index = Number(props.className.substring(n + 1));
  const fieldState = form.getFieldState(source);
  const data = fieldState ? fieldState.value[index] : undefined;
  const [open, setOpen] = useState(false);

  const handleDialogOpen = () => setOpen(true);
  const handleDialogClose = () => setOpen(false);

  const handleRemove = async (event) => {
    props.onClick(event);
    setOpen(false);
    refreshFn && refreshFn();
  };

  return (
    <>
      <Button
        label="Remove"
        color="default"
        onClick={data?.id ? handleDialogOpen : handleRemove}
      >
        <RemoveIcon />
      </Button>
      <Confirm
        isOpen={open}
        title={"Delete Confirmation"}
        content={
          "Removing a Field will make it unavialble for future use. Existing reocrds with this field will not be affected. Are you sure you want to delete this Field? "
        }
        onConfirm={handleRemove}
        onClose={handleDialogClose}
      />
    </>
  );
};

const AddButtonDefault = ({ source, displayValues, refreshFn, ...props }) => {
  const form = useForm();
  const fieldState = form.getFieldState(source);

  const handleAdd = (event) => {
    debugger;
    if (fieldState?.value)
      form.change(source, [
        ...fieldState.value,
        { display: displayValues, required: false },
      ]);
    else form.change(source, [{ display: displayValues, required: false }]);
    refreshFn && refreshFn();
  };

  return (
    <Button label="Add" color="default" onClick={handleAdd}>
      <AddIcon />
    </Button>
  );
};

const CustomFieldsInput = ({
  source,
  label = false,
  displayValues,
  refreshFn,
  className,
  ...props
}) => {
  const form = useForm();
  const classes = useStyles();
  const displayOptions = CustomFieldsDisplayOptions.filter((option) =>
    displayValues.includes(option.id)
  );

  const handleNameChange = (event, getSource) => {
    debugger;
    if (event.target.value) {
      const id = getCustomFieldId(event.target.value);
      form.change(getSource("id"), id);
      refreshFn && refreshFn();
    }
  };

  return (
    <ArrayInput source={source} label={label} fullWidth className={className}>
      <SimpleFormIterator
        addButton={
          <AddButtonDefault source={source} displayValues={displayValues} />
        }
        removeButton={
          <DeepRemoveButton source={source} refreshFn={refreshFn} />
        }
      >
        <FormDataConsumer>
          {({
            formData,
            scopedFormData, // The data for this item of the ArrayInput
            getSource, // Function to get the valid source inside an ArrayInput. Translates to "inventories.items[].property"
            ...rest
          }) => (
            <Grid container direction="row" spacing={1}>
              <Grid item xs={12} md={4}>
                <TextInput
                  source={getSource("name")}
                  label="Field Name"
                  variant="outlined"
                  fullWidth
                  required
                  validate={(value) => validateUnicity(value, formData, source)}
                  onChange={(event) => handleNameChange(event, getSource)}
                  helperText={false}
                />
              </Grid>
              <Grid item xs={12} md={2}>
                <RadioButtonGroupInput
                  source={getSource("required")}
                  label="Required"
                  row
                  choices={TrueOrFalse}
                  defaultValue={false}
                  style={{
                    marginTop: 0,
                    marginLeft: theme.spacing(1),
                  }}
                  helperText={false}
                />
              </Grid>
              {displayOptions?.length > 0 && (
                <Grid item xs={12} md={6}>
                  <CheckboxGroupInput
                    source={getSource("display")}
                    label="Display On..."
                    fullWidth
                    className={classes.checkbox}
                    choices={displayOptions}
                    helperText={false}
                    // initialValue={[CustomFieldsDisplayOptions[0]]} - infinnite loop, must upgrade react-admin
                  />
                </Grid>
              )}
            </Grid>
          )}
        </FormDataConsumer>
      </SimpleFormIterator>
    </ArrayInput>
  );
};

export default CustomFieldsInput;
